import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "profile max-width-text" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "profile-field half-width" }
const _hoisted_4 = { class: "profile-field__label" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "profile-field half-width mr-2" }
const _hoisted_8 = { class: "profile-field__label" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "profile-field half-width" }
const _hoisted_11 = { class: "profile-field__label" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "profile-field half-width mr-2" }
const _hoisted_15 = { class: "profile-field__label" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "profile-field half-width" }
const _hoisted_18 = { class: "profile-field__label" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "profile-field half-width" }
const _hoisted_21 = { class: "profile-field__label" }
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "error-message"
}
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "flex-grow-1 mr-2" }
const _hoisted_27 = {
  key: 1,
  class: "gray3--text"
}
const _hoisted_28 = { class: "flex-grow-1" }
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = { class: "profile-radio-group" }
const _hoisted_32 = { class: "profile-field__label" }
const _hoisted_33 = { class: "profile-radio-group__options" }
const _hoisted_34 = { class: "profile-radio" }
const _hoisted_35 = ["checked", "disabled"]
const _hoisted_36 = { class: "profile-radio" }
const _hoisted_37 = ["checked", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.YOUR_PROFILE')), 1),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.PERSONAL_INFORMATION')), 1),
    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.ROLE')), 1),
      _createElementVNode("input", {
        class: "profile-field__input",
        type: "text",
        value: _ctx.currentUser.roleName,
        disabled: ""
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.FIRST_NAME')), 1),
        _createElementVNode("input", {
          class: "profile-field__input",
          type: "text",
          value: _ctx.currentUser.firstName,
          disabled: ""
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.LAST_NAME')), 1),
        _createElementVNode("input", {
          class: "profile-field__input",
          type: "text",
          value: _ctx.currentUser.lastName,
          disabled: ""
        }, null, 8, _hoisted_12)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('COMMON.EMAIL')), 1),
        _createElementVNode("input", {
          class: "profile-field__input",
          type: "text",
          value: _ctx.currentUser.userName,
          disabled: ""
        }, null, 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.STATUS_PORTAL')), 1),
        _createElementVNode("input", {
          class: "profile-field__input",
          type: "text",
          value: _ctx.currentUser.status,
          disabled: ""
        }, null, 8, _hoisted_19)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.USER.EMAIL_LANGUAGE')), 1),
      _createElementVNode("select", {
        class: "profile-field__input",
        value: _ctx.currentUser.language || "",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLanguageChange && _ctx.onLanguageChange(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localeOptions, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.id,
            value: option.value
          }, _toDisplayString(option.title), 9, _hoisted_23))
        }), 128))
      ], 40, _hoisted_22),
      (_ctx.errorMessage("language"))
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errorMessage("language")), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.YOUR_NOTIFICATIONS')), 1),
    _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.DOCUMENT_NOTIFICATION')), 1),
        (_ctx.currentUser)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentUser.notificationSubscriptions, (subscription, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "subscription mb-2 flex flex-align-center",
                key: i
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["mr-05", _ctx.getIcon(subscription.type)])
                }, null, 2),
                _createTextVNode(_toDisplayString(_ctx.$t(`MY_ENVIRONMENT.NOTIFICATION.${subscription.type.toUpperCase()}`)), 1)
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.currentUser.notificationSubscriptions.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.NO_SUBSCRIPTIONS')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.GENERAL_NOTIFICATION')), 1),
        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.GENERAL_NOTIFICATION_TEXT')), 1),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.PROFILE.RECEIVE_GENERAL_NOTIFICATION')), 1),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("label", _hoisted_34, [
              _createElementVNode("input", {
                type: "radio",
                name: "enabled-general-notification",
                checked: _ctx.currentUser.enabledGeneralNotification === true,
                disabled: (_ctx.impersonated && !_ctx.impersonatedWithOriginalRights),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onGeneralNotificationChange(true)))
              }, null, 40, _hoisted_35),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('COMMON.YES')), 1)
            ]),
            _createElementVNode("label", _hoisted_36, [
              _createElementVNode("input", {
                type: "radio",
                name: "enabled-general-notification",
                checked: _ctx.currentUser.enabledGeneralNotification === false,
                disabled: (_ctx.impersonated && !_ctx.impersonatedWithOriginalRights),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onGeneralNotificationChange(false)))
              }, null, 40, _hoisted_37),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('COMMON.NO')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}